module.exports = __webpack_public_path__ + "img/usdc.b0cdaec4.svg";